export const languagesList = [
  { value: 'es', label: 'spanish', id: 1 },
  { value: 'fr', label: 'french', id: 2 },
  { value: 'en', label: 'english', id: 4 },
  { value: 'pt', label: 'portuguese', id: 3 },
];
